import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import {
    API_URL_SEND_CODE,
    API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP,
    API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN,
    API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_TO_B2B,
    VERIFICATION_TARGET,
} from "../../../../../constants";
import { RootState } from "../../../../../models";
import * as Ajax from "../../../app/Ajax";
import { VerificationDeliveryMethod } from "../../consts";
import * as AT from "../actionTypes";

export const sendCode =
    (
        phoneNumber: string,
        deliveryMethod: VerificationDeliveryMethod,
    ): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        const onlyDigits = (phoneNumber || "").replace(/\s/g, "");

        dispatch({
            type: AT.CHECKOUT_SEND_CODE,
            payload: Ajax.post(
                {
                    url: API_URL_SEND_CODE,
                    data: {
                        phoneNumber: onlyDigits,
                        target: VERIFICATION_TARGET.TRANSFER_OWNERSHIP_TO_B2C,
                        deliveryMethod,
                    },
                },
                dispatch,
            ),
        });
    };

export const verifyCodeTransferOwnership =
    (pin: string, phoneNumber: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP,
            meta: {
                flashOnError: true,
                target: VERIFICATION_TARGET.TRANSFER_OWNERSHIP_TO_B2C,
            },
            payload: Ajax.post(
                {
                    url: API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP,
                    data: { pin, phoneNumber, target: VERIFICATION_TARGET.TRANSFER_OWNERSHIP_TO_B2C },
                },
                dispatch,
            ),
        });
    };

export const verifyCodeTransferOwnershipToB2B =
    (pin: string, phoneNumber: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP,
            meta: {
                flashOnError: true,
                target: VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_PORTIN_B2B,
            },
            payload: Ajax.post(
                {
                    url: API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_TO_B2B,
                    data: { pin, phoneNumber, target: VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_PORTIN_B2B },
                },
                dispatch,
            ),
        });
    };

export const verifyCodeTransferOwnershipExistingCompanyAdmin =
    (pin: string, phoneNumber: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        dispatch({
            type: AT.CHECKOUT_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN,
            meta: {
                flashOnError: true,
                target: VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B,
            },
            payload: Ajax.post(
                {
                    url: API_URL_VERIFY_CODE_TRANSFER_OWNERSHIP_EXISTING_COMPANY_ADMIN,
                    data: { pin, phoneNumber, target: VERIFICATION_TARGET.FORMER_LEGAL_OWNER_CONSENT_TRANSFER_B2B },
                },
                dispatch,
            ),
        });
    };
